const Bucket: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      width="36"
      height="34"
      fill="none"
      viewBox="0 0 36 34"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={props.className ?? ''}>
      <path
        fill="currentColor"
        d="M16.2 0V3.57895H18.3059C17.6367 5.04343 17.0867 6.62502 16.6289 8.9928C15.2483 7.90783 13.5844 7.15789 11.7 7.15789C7.56651 7.15789 4.25414 10.3262 3.78281 14.3158H1.8C1.32262 14.3158 0.864816 14.5044 0.527261 14.84C0.189705 15.1755 4.77827e-05 15.6307 5.23871e-08 16.1053V19.6807C-4.9053e-05 19.8831 0.0344242 20.084 0.101953 20.2749L4.52109 32.8012C4.64427 33.1513 4.87383 33.4547 5.17803 33.6695C5.48223 33.8843 5.84604 33.9998 6.21914 34H29.7844C30.1575 33.9998 30.5213 33.8843 30.8255 33.6695C31.1297 33.4547 31.3592 33.1513 31.4824 32.8012L35.898 20.2749C35.9652 20.0851 35.9997 19.8854 36 19.6842V16.1053C36 15.6307 35.8103 15.1755 35.4727 14.84C35.1352 14.5044 34.6774 14.3158 34.2 14.3158H32.4V12.5263C32.4 8.76478 31.2862 5.75006 30.2941 3.57895H32.4V0H27.5273H21.15H16.2ZM22.2961 3.57895H26.3039C26.9061 4.7282 28.8 8.50899 28.8 12.5263V14.3158H19.8V12.5263C19.8 8.50899 21.6939 4.7282 22.2961 3.57895ZM11.7 10.7368C13.853 10.7368 15.3731 12.3242 15.8309 14.3158H7.56914C8.02692 12.3242 9.547 10.7368 11.7 10.7368ZM3.6 17.8947H18H32.4V19.3801L28.5047 30.4211H19.8V25.0526H25.2L18 17.8947L10.8 25.0526H16.2V30.4211H7.49531L3.6 19.3766V17.8947Z"
      />
    </svg>
  );
};

export default Bucket;
